export default __webpack_public_path__ + "static/media/misc-closetB-2048w.5862b55c.avif";